(() => {
  const root = document.documentElement;
  const system = matchMedia('(prefers-reduced-motion: reduce)');
  let chosen;
  try { chosen = localStorage.getItem('lnt-reduce-motion'); } catch {}
  const update = (reduced) => {
    root.classList.toggle('lnt-reduced-motion', reduced);
    document.querySelectorAll('[data-lnt-motion]').forEach(button => {
      button.setAttribute('aria-pressed', String(reduced));
      button.textContent = reduced ? 'Activar animaciones' : 'Reducir movimiento';
    });
    document.dispatchEvent(new CustomEvent('lnt:motion', {detail:{reduced}}));
  };
  update(system.matches || chosen === 'true');
  system.addEventListener('change', () => update(system.matches || chosen === 'true'));
  document.addEventListener('click', event => {
    if (event.target.closest('[data-lnt-motion]')) {
      chosen = String(!root.classList.contains('lnt-reduced-motion'));
      try { localStorage.setItem('lnt-reduce-motion', chosen); } catch {}
      update(system.matches || chosen === 'true');
    }
    const filter = event.target.closest('[data-lnt-filter]');
    if (!filter) return;
    const section = filter.closest('.op-featured');
    section.querySelectorAll('[data-lnt-filter]').forEach(button => button.setAttribute('aria-pressed', String(button === filter)));
    section.querySelectorAll('[data-lnt-category]').forEach(card => card.hidden = filter.dataset.lntFilter !== 'all' && card.dataset.lntCategory !== filter.dataset.lntFilter);
  });
  const observer = new IntersectionObserver(entries => entries.forEach(entry => {
    if (entry.isIntersecting) { entry.target.removeAttribute('data-lnt-pending'); observer.unobserve(entry.target); }
  }), {threshold:.05});
  document.querySelectorAll('.op-home-section-heading,.op-manifesto-grid,.op-collections__card,.op-featured-product').forEach(el => {
    el.classList.add('lnt-reveal'); el.setAttribute('data-lnt-pending',''); observer.observe(el);
  });
})();
